import { RouteConfig } from '@abaco/web-common/src/app';

const routes: RouteConfig[] = [
    {
        name: "activities",
        path: "/activities",
        component: () => import("./components/SingleTileContainer.vue"),
        props: {tileId: "calendar-activity-tile"},
        meta: { navbarItems: [ {component: "farm-select-nav-bar-item", props: { ["is-required"]: true }}, "campaign-select-nav-bar-item", "plot-selection-nav-bar-item"] }
    },
    {
        name: "activities-plan-activity-mode",
        path: "/activities-plan-activity-mode",
        component: () => import("./components/ActivitiesAddActivityContainer.vue"),
        props: {tileId: "calendar-activity-tile", mode: "activity"},
        meta: { navbarItems: [ "farm-select-nav-bar-item", "campaign-select-nav-bar-item", "plot-selection-nav-bar-item"] }
    },
    {
        name: "activities-execute-activity-mode",
        path: "/activities-execute-activity-mode",
        component: () => import("./components/ActivitiesAddActivityContainer.vue"),
        props: {tileId: "calendar-activity-tile", mode: "action"},
        meta: { navbarItems: [ "farm-select-nav-bar-item", "campaign-select-nav-bar-item", "plot-selection-nav-bar-item"] }
    },
    {
        name: "activities-product-print",
        path: "/activities-product-print/:productId",
        component: () => import("./components/tiles/ProductPrint.vue"),
        props: true
    },
    {
        name: "activities-detail",
        path: "/activities/:activity_id",
        component: () => import("./components/DirectDetailContainer.vue"),
        props: {tileId: "calendar-activity-tile"},
        meta: { navbarItems: [ "farm-select-nav-bar-item", "campaign-select-nav-bar-item", "plot-selection-nav-bar-item"] }
    }
];

export default routes;
